export const DARK_MODE_BACKGROUND_COLOR = "#1D1C1F";

export const TRADE_GOTHIC_NEXT_FONT_FAMILY =
  "trade-gothic-next, arial, sans-serif";
export const TRADE_GOTHIC_NEXT_CONDENSED_FONT_FAMILY =
  "trade-gothic-next-condensed, sans-serif";

export const TRADE_GOTHIC_NEXT_FONT_CSS_HREF =
  "https://use.typekit.net/hde4vbh.css";

export const INTER_FONT_CSS_HREF =
  "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap";
